import { Component, Input, OnInit } from '@angular/core';
import { ClassSchedule } from 'src/app/core/models/api/class-schedule.model';

@Component({
    selector: 'app-courses-summary-table',
    templateUrl: './courses-summary-table.component.html',
    styleUrls: ['./courses-summary-table.component.scss']
})
export class CoursesSummaryTableComponent implements OnInit {

    @Input() classes        : ClassSchedule[];
    @Input() openEnrollments: boolean;
    @Input() showFreePlaces : boolean;
    @Input() showOccupation : boolean;

    constructor() { }

    ngOnInit() { }

    getClassOccupation(courseClass: ClassSchedule) : string {

        var percentage = (courseClass.reservedPlaces * 100) / courseClass.totalPlaces;
        
        if (percentage >= 80) {
            return 'custom-courses-summary-high-occupation';
        } else if (percentage >= 50) {
            return 'custom-courses-summary-medium-occupation';
        } else {
            return 'custom-courses-summary-low-occupation';
        }

    }

}
